import type { AssessmentQuestion } from '@entities/assessment'

import { AssessmentTopics } from '@entities/assessment'

import imgQuestion1 from '../../../../ui/images/questions/ela/grade-k3/question-1.png'
import imgQuestion9 from '../../../../ui/images/questions/ela/grade-k3/question-9.png'
import imgQuestion12 from '../../../../ui/images/questions/ela/grade-k3/question-12.png'

export const questionsTest: AssessmentQuestion[] = [
  {
    name: 'grade_k3_1',
    title: 'Which word has the same beginning sound as "school"?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    image: imgQuestion1,
    answers: [
      {
        name: 'grade_k3_1_a',
        text: 'spoon',
      },
      {
        name: 'grade_k3_1_b',
        text: 'cool',
      },
      {
        name: 'grade_k3_1_c',
        text: 'skate',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k3_2',
    title: 'Which word best describes the tone of a person saying:',
    topic: AssessmentTopics.ListeningAndSpeaking,
    detail: '"I am absolutely certain that we will win this game if we work together"',
    answers: [
      {
        name: 'grade_k3_2_a',
        text: 'Angry',
      },
      {
        name: 'grade_k3_2_b',
        text: 'Confident',
        correct: true,
      },
      {
        name: 'grade_k3_2_c',
        text: 'Doubtful',
      },
    ],
  },
  {
    name: 'grade_k3_3',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ListeningAndSpeaking,
    detail: '"We sat on the muddy bank and watched the frogs jump into the river."',
    sentence: 'Which sentence uses the word \'bank\' in the same way:',
    answers: [
      {
        name: 'grade_k3_3_a',
        text: 'The hikers built a campfire on the north bank of the creek.',
        correct: true,
      },
      {
        name: 'grade_k3_3_b',
        text: 'I need to go to the bank to deposit my birthday money.',
      },
      {
        name: 'grade_k3_3_c',
        text: 'The airplane had to bank left to avoid the storm clouds.',
      },
    ],
  },
  {
    name: 'grade_k3_4',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"Emma carefully placed the small, delicate vase on the shelf so it wouldnʼt fall and break."',
    sentence: 'Why did Emma place the vase carefully?',
    answers: [
      {
        name: 'grade_k3_4_a',
        text: 'She wanted it to look pretty.',
      },
      {
        name: 'grade_k3_4_b',
        text: 'So it wouldn\'t slip and fall onto the floor.',
        correct: true,
      },
      {
        name: 'grade_k3_4_c',
        text: 'Because it was heavy.',
      },
    ],
  },
  {
    name: 'grade_k3_5',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"While some people think bats are scary, they are actually very helpful to farmers because they eat thousands of insects that would otherwise destroy crops."',
    sentence: 'What is the main idea of this sentence?',
    answers: [
      {
        name: 'grade_k3_5_a',
        text: 'Farmers should be afraid of bats.',
      },
      {
        name: 'grade_k3_5_b',
        text: 'Bats are beneficial despite people\'s fears.',
        correct: true,
      },
      {
        name: 'grade_k3_5_c',
        text: 'Insects are more important than bats.',
      },
    ],
  },
  {
    name: 'grade_k3_6',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"When the teacher walked into the room, she saw a broken flower pot on the floor and two muddy paw prints leading to the open window."',
    sentence: 'Who probably broke the flower pot?',
    answers: [
      {
        name: 'grade_k3_6_a',
        text: 'A student who was late for class.',
      },
      {
        name: 'grade_k3_6_b',
        text: 'An animal that came in from outside.',
        correct: true,
      },
      {
        name: 'grade_k3_6_c',
        text: 'The teacher herself.',
      },
    ],
  },
  {
    name: 'grade_k3_7',
    title: 'Choose the correct words to complete the sentence:',
    topic: AssessmentTopics.Writing,
    detail: '______ are three birds sitting on ______ nest.',
    answers: [
      {
        name: 'grade_k3_7_a',
        text: 'Their / there',
      },
      {
        name: 'grade_k3_7_b',
        text: 'There / their',
        correct: true,
      },
      {
        name: 'grade_k3_7_c',
        text: 'They\'re / there',
      },
    ],
  },
  {
    name: 'grade_k3_8',
    title: 'Choose the best transition word to connect these two ideas:',
    topic: AssessmentTopics.Writing,
    detail: 'I really wanted to go to the beach. ______, it started to thunder, so we stayed home.',
    answers: [
      {
        name: 'grade_k3_8_a',
        text: 'Therefore',
      },
      {
        name: 'grade_k3_8_b',
        text: 'However',
        correct: true,
      },
      {
        name: 'grade_k3_8_c',
        text: 'In addition',
      },
    ],
  },
  {
    name: 'grade_k3_9',
    title: 'Choose the sentence that has the most informative description:',
    topic: AssessmentTopics.Writing,
    image: imgQuestion9,
    answers: [
      {
        name: 'grade_k3_9_a',
        text: 'The dog runs.',
      },
      {
        name: 'grade_k3_9_b',
        text: 'The dog runs fast.',
      },
      {
        name: 'grade_k3_9_c',
        text: 'The big, brown dog runs fast in the park.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k3_10',
    title: 'Which word is a noun in this sentence?',
    topic: AssessmentTopics.Language,
    detail: 'The students played soccer on the field.',
    answers: [
      {
        name: 'grade_k3_10_a',
        text: 'played',
      },
      {
        name: 'grade_k3_10_b',
        text: 'students',
        correct: true,
      },
      {
        name: 'grade_k3_10_c',
        text: 'on',
      },
    ],
  },
  {
    name: 'grade_k3_11',
    title: 'Which adjective correctly completes this comparison?',
    topic: AssessmentTopics.Language,
    detail: 'This is the ______ book I have ever read!',
    answers: [
      {
        name: 'grade_k3_11_a',
        text: 'better',
      },
      {
        name: 'grade_k3_11_b',
        text: 'best',
        correct: true,
      },
      {
        name: 'grade_k3_11_c',
        text: 'goodest',
      },
    ],
  },
  {
    name: 'grade_k3_12',
    title: 'Which word is an adjective in this sentence?',
    topic: AssessmentTopics.Language,
    detail: 'The bright sun shined all day.',
    image: imgQuestion12,
    answers: [
      {
        name: 'grade_k3_12_a',
        text: 'bright',
        correct: true,
      },
      {
        name: 'grade_k3_12_b',
        text: 'sun',
      },
      {
        name: 'grade_k3_12_c',
        text: 'shined',
      },
    ],
  },
]
